import * as React from 'react';
// Material UI
import { Grid, TextField, Button, Container, } from '@mui/material';
//Components
import { Dialog } from "@progress/kendo-react-dialogs";

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// My components
import MyCard from '../../../shared/components/myCard'
//My Tools
// Custom Styles



const EditPopupForm = (props) => {
    const defaultInputValues = {
        name: props.item.name
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Rol adı girilmesi gereklidir')
    });

    const submitData = () => {
        props.onSubmit(getValues("name"), props.item.id);
    };


    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
    } = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });



    return (

        <Container noValidate autoComplete="off">
            <Dialog title={`Güncellenen: ${props.item.name}`} onClose={props.cancelEdit}>
                <MyCard header="Rol Güncelle">
                    <Grid container spacing={2} direction="row" justify="center" >
                        <Grid item xs={8}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="name"
                                label="Rol Adı:"
                                variant="outlined"
                                size="small"

                                {...register('name')}
                                error={errors.name ? true : false}
                                helperText={errors.name?.message}
                            />
                        </Grid>
                        <Grid item xs={4}>

                            <Button variant="outlined" onClick={handleSubmit(submitData)}>
                                Güncelle
                            </Button>

                        </Grid>
                    </Grid>
                </MyCard>
            </Dialog>

        </Container>

    );
};

export default EditPopupForm;